import { Heading } from '@mm/components';
import React, { useState } from 'react';
import { useCookies } from 'react-cookie';
import classnames from 'classnames';
import {
  ModalBody,
  ModalFooter,
  CloseModalProps,
  ModalHeader,
} from '../modal-helpers';
import './ConfirmStoryMentionModal.pcss';
import {
  PrimaryButton,
  ButtonColor,
} from '../../buttons/PrimaryButton/PrimaryButton';

type Props = {
  createStarter: () => void;
} & CloseModalProps;

const DONT_SHOW_STORY_MENTION_POPUP = 'dont_show_story_mention_popup';

export const ConfirmStoryMentionModal = (props: Props) => {
  const { closeModal, createStarter } = props;

  const [cookies, setCookie] = useCookies([DONT_SHOW_STORY_MENTION_POPUP]);
  const [showAgain, setShowAgain] = useState(true);

  const onCloseHandler = (ok: boolean) => {
    if (ok) {
      if (!showAgain) {
        setCookie(DONT_SHOW_STORY_MENTION_POPUP, true);
      }
      createStarter();
    }
  };

  const onClose = (ok: boolean) => {
    closeModal();
    onCloseHandler(ok);
  };

  const classname = classnames('confirm-story-mention-modal');

  return (
    <div className={classname}>
      <ModalHeader className="confirm-story-mention-modal__header">
        <Heading
          size={3}
          text="You already have a Story Mention Autoresponder"
        />
      </ModalHeader>
      <ModalBody className="confirm-story-mention-modal__body">
        You can create new ones, and we’ll send them at random, this way your
        followers don’t get the same messages again and again.
        <div className="confirm-story-mention-modal__body-checkbox">
          <input
            type="checkbox"
            checked={!showAgain}
            onChange={() => setShowAgain(prevValue => !prevValue)}
          />
          Don't show me this again
        </div>
      </ModalBody>

      <ModalFooter className="confirm-story-mention-modal__footer">
        <PrimaryButton
          className="confirm-story-mention-modal__button--cancel"
          color={ButtonColor.gray}
          onClick={() => onClose(false)}
        >
          Cancel
        </PrimaryButton>
        <PrimaryButton
          color={ButtonColor.blue}
          className="confirm-story-mention-modal__button"
          onClick={() => onClose(true)}
        >
          Create
        </PrimaryButton>
      </ModalFooter>
    </div>
  );
};
